import { Menu, tombac } from 'tombac';
import { DeleteIcon, ForwardIcon, MenuKebabIcon } from 'tombac-icons';
import { OrganizationButton } from "./OrganizationShared";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function OrganizationTreeItemMenu({
  onDelete,
  onMoveTo,
  showDelete = false,
  showMoveTo = false
}) {
  if (!showMoveTo && !showDelete) return null;
  const handleAction = action => {
    switch (action) {
      case 'move-to':
        onMoveTo();
        break;
      case 'delete':
        onDelete?.();
        break;
    }
  };
  return /*#__PURE__*/_jsxs(Menu.Dropdown, {
    onAction: handleAction,
    placement: "bottom end",
    trigger: ({
      triggerProps
    }) => /*#__PURE__*/_jsx(OrganizationButton, {
      ...triggerProps,
      shape: "circle",
      children: /*#__PURE__*/_jsx(MenuKebabIcon, {})
    }),
    "data-sentry-element": "unknown",
    "data-sentry-component": "OrganizationTreeItemMenu",
    "data-sentry-source-file": "OrganizationTreeItemMenu.tsx",
    children: [showMoveTo && /*#__PURE__*/_jsx(Menu.Item, {
      prepend: /*#__PURE__*/_jsx(ForwardIcon, {}),
      children: "Move to\u2026"
    }, "move-to"), showDelete &&
    /*#__PURE__*/
    /* {showMoveTo && <Menu.Separator />} */
    _jsx(Menu.Item, {
      $color: tombac.color('danger'),
      prepend: /*#__PURE__*/_jsx(DeleteIcon, {}),
      children: "Delete"
    }, "delete")]
  });
}